import { axiosInstance } from "authProvider";
import { API_URL } from "../../constants";

export const getFarmers =
  () =>
    async (): Promise<[]> => {
      return await axiosInstance
        .get(`${API_URL}/api/farmers?populate=*`)
        .then(({ data }) => data);
    };
